// GENERATED — do not hand-edit. Google libaddressinput address metadata as
// shipped by lib-address@0.7.0 (MIT, sha512-3rZ/KCwCotNA032W+PMfKAqmXNgs+PwTW099z6Uxf4lRRIIcOPTclO3LrSjkxJjIVNSfhITSTmWyW1wY8LM5NQ==),
// pruned to what the billing address form uses: [lfmt, zip pattern, required].
// Vendored rather than installed: lib-address declares engines node >=22.12,
// which makes Yarn 1 refuse `yarn install` on this repo's node:18 Docker build.
// Regenerate from an unpacked `npm pack lib-address@<version>` (package/):
//   COUNTRIES[code] = [lfmt, zip, require] from dist/entry-lite.mjs's
//     getCountryData(code), for every countries/<code>.json;
//   NAME_TYPES[code] = countries/<code>.json's locality_name_type (city),
//     state_name_type (state), zip_name_type (zip) — only where the field is
//     in lfmt and the type differs from the default city/province/postal.
// Once the build runs on Node >= 22.12, prefer installing lib-address and
// importing getCountryData from 'lib-address/lite' instead of this file.

// [lfmt, zip, require] per ISO 3166-1 alpha-2 code
const COUNTRIES = {
  AC: ['%N%n%O%n%A%n%C%n%Z', 'ASCN 1ZZ', null],
  AD: ['%N%n%O%n%A%n%Z %C', 'AD[1-7]0\\d', null],
  AE: ['%N%n%O%n%A%n%S', null, 'AS'],
  AF: ['%N%n%O%n%A%n%C%n%Z', '\\d{4}', null],
  AG: [null, null, 'A'],
  AI: ['%N%n%O%n%A%n%C%n%Z', '(?:AI-)?2640', null],
  AL: ['%N%n%O%n%A%n%Z%n%C', '\\d{4}', null],
  AM: ['%N%n%O%n%A%n%Z%n%C%n%S', '(?:37)?\\d{4}', null],
  AO: [null, null, null],
  AQ: [null, null, null],
  AR: ['%N%n%O%n%A%n%Z %C%n%S', '((?:[A-HJ-NP-Z])?\\d{4})([A-Z]{3})?', null],
  AS: ['%N%n%O%n%A%n%C %S %Z', '(96799)(?:[ \\-](\\d{4}))?', 'ACSZ'],
  AT: ['%O%n%N%n%A%n%Z %C', '\\d{4}', 'ACZ'],
  AU: ['%O%n%N%n%A%n%C %S %Z', '\\d{4}', 'ACSZ'],
  AW: [null, null, null],
  AX: ['%O%n%N%n%A%nAX-%Z %C%nÅLAND', '22\\d{3}', 'ACZ'],
  AZ: ['%N%n%O%n%A%nAZ %Z %C', '\\d{4}', null],
  BA: ['%N%n%O%n%A%n%Z %C', '\\d{5}', null],
  BB: ['%N%n%O%n%A%n%C, %S %Z', 'BB\\d{5}', null],
  BD: ['%N%n%O%n%A%n%C - %Z', '\\d{4}', null],
  BE: ['%O%n%N%n%A%n%Z %C', '\\d{4}', 'ACZ'],
  BF: ['%N%n%O%n%A%n%C %X', null, null],
  BG: ['%N%n%O%n%A%n%Z %C', '\\d{4}', null],
  BH: ['%N%n%O%n%A%n%C %Z', '(?:^|\\b)(?:1[0-2]|[1-9])\\d{2}(?:$|\\b)', null],
  BI: [null, null, null],
  BJ: [null, null, null],
  BL: ['%O%n%N%n%A%n%Z %C %X', '9[78][01]\\d{2}', 'ACZ'],
  BM: ['%N%n%O%n%A%n%C %Z', '[A-Z]{2} ?[A-Z0-9]{2}', null],
  BN: ['%N%n%O%n%A%n%C %Z', '[A-Z]{2} ?\\d{4}', null],
  BO: [null, null, null],
  BQ: [null, null, null],
  BR: ['%O%n%N%n%A%n%D%n%C-%S%n%Z', '\\d{5}-?\\d{3}', 'ASCZ'],
  BS: ['%N%n%O%n%A%n%C, %S', null, null],
  BT: ['%N%n%O%n%A%n%C %Z', '\\d{5}', null],
  BV: [null, null, null],
  BW: [null, null, null],
  BY: ['%O%n%N%n%A%n%Z, %C%n%S', '\\d{6}', null],
  BZ: [null, null, null],
  CA: [
    '%N%n%O%n%A%n%C %S %Z',
    '[ABCEGHJKLMNPRSTVXY]\\d[ABCEGHJ-NPRSTV-Z] ?\\d[ABCEGHJ-NPRSTV-Z]\\d',
    'ACSZ',
  ],
  CC: ['%O%n%N%n%A%n%C %S %Z', '6799', null],
  CD: [null, null, null],
  CF: [null, null, null],
  CG: [null, null, null],
  CH: ['%O%n%N%n%A%nCH-%Z %C', '\\d{4}', 'ACZ'],
  CI: ['%N%n%O%n%X %A %C %X', null, null],
  CK: [null, null, null],
  CL: ['%N%n%O%n%A%n%Z %C%n%S', '\\d{7}', null],
  CM: [null, null, null],
  CN: ['%N%n%O%n%A%n%D%n%C%n%S, %Z', '\\d{6}', 'ACSZ'],
  CO: ['%N%n%O%n%A%n%D%n%C, %S, %Z', '\\d{6}', 'AS'],
  CR: ['%N%n%O%n%A%n%S, %C%n%Z', '\\d{4,5}|\\d{3}-\\d{4}', 'ACS'],
  CU: ['%N%n%O%n%A%n%C %S%n%Z', '\\d{5}', null],
  CV: ['%N%n%O%n%A%n%Z %C%n%S', '\\d{4}', null],
  CW: [null, null, null],
  CX: ['%O%n%N%n%A%n%C %S %Z', '6798', null],
  CY: ['%N%n%O%n%A%n%Z %C', '\\d{4}', null],
  CZ: ['%N%n%O%n%A%n%Z %C', '\\d{3} ?\\d{2}', 'ACZ'],
  DE: ['%N%n%O%n%A%n%Z %C', '\\d{5}', 'ACZ'],
  DJ: [null, null, null],
  DK: ['%N%n%O%n%A%n%Z %C', '\\d{4}', 'ACZ'],
  DM: [null, null, null],
  DO: ['%N%n%O%n%A%n%Z %C', '\\d{5}', null],
  DZ: ['%N%n%O%n%A%n%Z %C', '\\d{5}', null],
  EC: ['%N%n%O%n%A%n%Z%n%C', '\\d{6}', null],
  EE: ['%N%n%O%n%A%n%Z %C %S', '\\d{5}', 'ACZ'],
  EG: ['%N%n%O%n%A%n%C%n%S%n%Z', '\\d{5}', null],
  EH: ['%N%n%O%n%A%n%Z %C', '\\d{5}', null],
  ER: [null, null, null],
  ES: ['%N%n%O%n%A%n%Z %C %S', '\\d{5}', 'ACSZ'],
  ET: ['%N%n%O%n%A%n%Z %C', '\\d{4}', null],
  FI: ['%O%n%N%n%A%nFI-%Z %C', '\\d{5}', 'ACZ'],
  FJ: [null, null, null],
  FK: ['%N%n%O%n%A%n%C%n%Z', 'FIQQ 1ZZ', 'ACZ'],
  FM: ['%N%n%O%n%A%n%C %S %Z', '(9694[1-4])(?:[ \\-](\\d{4}))?', 'ACSZ'],
  FO: ['%N%n%O%n%A%nFO%Z %C', '\\d{3}', null],
  FR: ['%O%n%N%n%A%n%Z %C', '\\d{2} ?\\d{3}', 'ACZ'],
  GA: [null, null, null],
  GB: [
    '%N%n%O%n%A%n%C%n%Z',
    'GIR ?0AA|(?:(?:AB|AL|B|BA|BB|BD|BF|BH|BL|BN|BR|BS|BT|BX|CA|CB|CF|CH|CM|CO|CR|CT|CV|CW|DA|DD|DE|DG|DH|DL|DN|DT|DY|E|EC|EH|EN|EX|FK|FY|G|GL|GY|GU|HA|HD|HG|HP|HR|HS|HU|HX|IG|IM|IP|IV|JE|KA|KT|KW|KY|L|LA|LD|LE|LL|LN|LS|LU|M|ME|MK|ML|N|NE|NG|NN|NP|NR|NW|OL|OX|PA|PE|PH|PL|PO|PR|RG|RH|RM|S|SA|SE|SG|SK|SL|SM|SN|SO|SP|SR|SS|ST|SW|SY|TA|TD|TF|TN|TQ|TR|TS|TW|UB|W|WA|WC|WD|WF|WN|WR|WS|WV|YO|ZE)(?:\\d[\\dA-Z]? ?\\d[ABD-HJLN-UW-Z]{2}))|BFPO ?\\d{1,4}',
    'ACZ',
  ],
  GD: [null, null, null],
  GE: ['%N%n%O%n%A%n%Z %C', '\\d{4}', null],
  GF: ['%O%n%N%n%A%n%Z %C %X', '9[78]3\\d{2}', 'ACZ'],
  GG: [
    '%N%n%O%n%A%n%C%nGUERNSEY%n%Z',
    'GY\\d[\\dA-Z]? ?\\d[ABD-HJLN-UW-Z]{2}',
    'ACZ',
  ],
  GH: [null, null, null],
  GI: ['%N%n%O%n%A%nGIBRALTAR%n%Z', 'GX11 1AA', 'A'],
  GL: ['%N%n%O%n%A%n%Z %C', '39\\d{2}', 'ACZ'],
  GM: [null, null, null],
  GN: ['%N%n%O%n%Z %A %C', '\\d{3}', null],
  GP: ['%O%n%N%n%A%n%Z %C %X', '9[78][01]\\d{2}', 'ACZ'],
  GQ: [null, null, null],
  GR: ['%N%n%O%n%A%n%Z %C', '\\d{3} ?\\d{2}', 'ACZ'],
  GS: ['%N%n%O%n%A%n%n%C%n%Z', 'SIQQ 1ZZ', 'ACZ'],
  GT: ['%N%n%O%n%A%n%Z- %C', '\\d{5}', null],
  GU: ['%N%n%O%n%A%n%C %Z', '(969(?:[12]\\d|3[12]))(?:[ \\-](\\d{4}))?', 'ACZ'],
  GW: ['%N%n%O%n%A%n%Z %C', '\\d{4}', null],
  GY: [null, null, null],
  HK: ['%N%n%O%n%A%n%C%n%S', null, 'AS'],
  HM: ['%O%n%N%n%A%n%C %S %Z', '\\d{4}', null],
  HN: ['%N%n%O%n%A%n%C, %S%n%Z', '\\d{5}', 'ACS'],
  HR: ['%N%n%O%n%A%nHR-%Z %C', '\\d{5}', null],
  HT: ['%N%n%O%n%A%nHT%Z %C', '\\d{4}', null],
  HU: ['%N%n%O%n%C%n%A%n%Z', '\\d{4}', 'ACZ'],
  ID: ['%N%n%O%n%A%n%C%n%S %Z', '\\d{5}', 'AS'],
  IE: ['%N%n%O%n%A%n%D%n%C%n%S%n%Z', '[\\dA-Z]{3} ?[\\dA-Z]{4}', null],
  IL: ['%N%n%O%n%A%n%C %Z', '\\d{5}(?:\\d{2})?', null],
  IM: ['%N%n%O%n%A%n%C%n%Z', 'IM\\d[\\dA-Z]? ?\\d[ABD-HJLN-UW-Z]{2}', 'ACZ'],
  IN: ['%N%n%O%n%A%n%C %Z%n%S', '\\d{6}', 'ACSZ'],
  IO: ['%N%n%O%n%A%n%C%n%Z', 'BBND 1ZZ', 'ACZ'],
  IQ: ['%O%n%N%n%A%n%C, %S%n%Z', '\\d{5}', 'ACS'],
  IR: ['%O%n%N%n%S%n%C, %D%n%A%n%Z', '\\d{5}-?\\d{5}', null],
  IS: ['%N%n%O%n%A%n%Z %C', '\\d{3}', null],
  IT: ['%N%n%O%n%A%n%Z %C %S', '\\d{5}', 'ACSZ'],
  JE: [
    '%N%n%O%n%A%n%C%nJERSEY%n%Z',
    'JE\\d[\\dA-Z]? ?\\d[ABD-HJLN-UW-Z]{2}',
    'ACZ',
  ],
  JM: ['%N%n%O%n%A%n%C%n%S %X', null, 'ACS'],
  JO: ['%N%n%O%n%A%n%C %Z', '\\d{5}', null],
  JP: ['%N%n%O%n%A, %S%n%Z', '\\d{3}-?\\d{4}', 'ASZ'],
  KE: ['%N%n%O%n%A%n%C%n%Z', '\\d{5}', null],
  KG: ['%N%n%O%n%A%n%Z %C', '\\d{6}', null],
  KH: ['%N%n%O%n%A%n%C %Z', '\\d{5,6}', null],
  KI: ['%N%n%O%n%A%n%S%n%C', null, null],
  KM: [null, null, null],
  KN: ['%N%n%O%n%A%n%C, %S', null, 'ACS'],
  KP: ['%N%n%O%n%A%n%C%n%S, %Z', null, null],
  KR: ['%N%n%O%n%A%n%D%n%C%n%S%n%Z', '\\d{5}', 'ACSZ'],
  KW: ['%N%n%O%n%A%n%Z %C', '\\d{5}', null],
  KY: ['%N%n%O%n%A%n%S %Z', 'KY\\d-\\d{4}', 'AS'],
  KZ: ['%Z%n%S%n%C%n%A%n%O%n%N', '\\d{6}', null],
  LA: ['%N%n%O%n%A%n%Z %C', '\\d{5}', null],
  LB: ['%N%n%O%n%A%n%C %Z', '(?:\\d{4})(?: ?(?:\\d{4}))?', null],
  LC: [null, null, null],
  LI: ['%O%n%N%n%A%nFL-%Z %C', '948[5-9]|949[0-8]', 'ACZ'],
  LK: ['%N%n%O%n%A%n%C%n%Z', '\\d{5}', null],
  LR: ['%N%n%O%n%A%n%Z %C', '\\d{4}', null],
  LS: ['%N%n%O%n%A%n%C %Z', '\\d{3}', null],
  LT: ['%O%n%N%n%A%nLT-%Z %C %S', '\\d{5}', 'ACZ'],
  LU: ['%O%n%N%n%A%nL-%Z %C', '\\d{4}', 'ACZ'],
  LV: ['%N%n%O%n%A%n%S%n%C, %Z', 'LV-\\d{4}', 'ACZ'],
  LY: [null, null, null],
  MA: ['%N%n%O%n%A%n%Z %C', '\\d{5}', null],
  MC: ['%N%n%O%n%A%nMC-%Z %C %X', '980\\d{2}', null],
  MD: ['%N%n%O%n%A%nMD-%Z %C', '\\d{4}', null],
  ME: ['%N%n%O%n%A%n%Z %C', '8\\d{4}', null],
  MF: ['%O%n%N%n%A%n%Z %C %X', '9[78][01]\\d{2}', 'ACZ'],
  MG: ['%N%n%O%n%A%n%Z %C', '\\d{3}', null],
  MH: ['%N%n%O%n%A%n%C %S %Z', '(969[67]\\d)(?:[ \\-](\\d{4}))?', 'ACSZ'],
  MK: ['%N%n%O%n%A%n%Z %C', '\\d{4}', null],
  ML: [null, null, null],
  MM: ['%N%n%O%n%A%n%C, %Z', '\\d{5}', null],
  MN: ['%N%n%O%n%A%n%C%n%S %Z', '\\d{5}', null],
  MO: ['%N%n%O%n%A', null, 'A'],
  MP: ['%N%n%O%n%A%n%C %S %Z', '(9695[012])(?:[ \\-](\\d{4}))?', 'ACSZ'],
  MQ: ['%O%n%N%n%A%n%Z %C %X', '9[78]2\\d{2}', 'ACZ'],
  MR: [null, null, null],
  MS: [null, null, null],
  MT: ['%N%n%O%n%A%n%C %Z', '[A-Z]{3} ?\\d{2,4}', null],
  MU: ['%N%n%O%n%A%n%Z%n%C', '\\d{3}(?:\\d{2}|[A-Z]{2}\\d{3})', null],
  MV: ['%N%n%O%n%A%n%C %Z', '\\d{5}', null],
  MW: ['%N%n%O%n%A%n%C %X', null, null],
  MX: ['%N%n%O%n%A%n%D%n%Z %C, %S', '\\d{5}', 'ACSZ'],
  MY: ['%N%n%O%n%A%n%D%n%Z %C%n%S', '\\d{5}', 'ACZ'],
  MZ: ['%N%n%O%n%A%n%Z %C%S', '\\d{4}', null],
  NA: ['%N%n%O%n%A%n%C%n%Z', '\\d{5}', null],
  NC: ['%O%n%N%n%A%n%Z %C %X', '988\\d{2}', 'ACZ'],
  NE: ['%N%n%O%n%A%n%Z %C', '\\d{4}', null],
  NF: ['%O%n%N%n%A%n%C %S %Z', '2899', null],
  NG: ['%N%n%O%n%A%n%D%n%C %Z%n%S', '\\d{6}', null],
  NI: ['%N%n%O%n%A%n%Z%n%C, %S', '\\d{5}', null],
  NL: [
    '%O%n%N%n%A%n%Z %C',
    '[1-9]\\d{3} ?(?:[A-RT-Z][A-Z]|S[BCE-RT-Z])',
    'ACZ',
  ],
  NO: ['%N%n%O%n%A%n%Z %C', '\\d{4}', 'ACZ'],
  NP: ['%N%n%O%n%A%n%C %Z', '\\d{5}', null],
  NR: ['%N%n%O%n%A%n%S', null, 'AS'],
  NU: [null, null, null],
  NZ: ['%N%n%O%n%A%n%D%n%C %Z', '\\d{4}', 'ACZ'],
  OM: ['%N%n%O%n%A%n%Z%n%C', '(?:PC )?\\d{3}', null],
  PA: ['%N%n%O%n%A%n%C%n%S', null, null],
  PE: [
    '%N%n%O%n%A%n%C %Z%n%S',
    '(?:LIMA \\d{1,2}|CALLAO 0?\\d)|[0-2]\\d{4}',
    null,
  ],
  PF: ['%N%n%O%n%A%n%Z %C %S', '987\\d{2}', 'ACSZ'],
  PG: ['%N%n%O%n%A%n%C %Z %S', '\\d{3}', 'ACS'],
  PH: ['%N%n%O%n%A%n%D, %C%n%Z %S', '\\d{4}', null],
  PK: ['%N%n%O%n%A%n%D%n%C-%Z', '\\d{5}', null],
  PL: ['%N%n%O%n%A%n%Z %C', '\\d{2}-\\d{3}', 'ACZ'],
  PM: ['%O%n%N%n%A%n%Z %C %X', '9[78]5\\d{2}', 'ACZ'],
  PN: ['%N%n%O%n%A%n%C%n%Z', 'PCRN 1ZZ', 'ACZ'],
  PR: ['%N%n%O%n%A%n%C PR %Z', '(00[679]\\d{2})(?:[ \\-](\\d{4}))?', 'ACZ'],
  PS: [null, null, null],
  PT: ['%N%n%O%n%A%n%Z %C', '\\d{4}-\\d{3}', 'ACZ'],
  PW: ['%N%n%O%n%A%n%C %S %Z', '(969(?:39|40))(?:[ \\-](\\d{4}))?', 'ACSZ'],
  PY: ['%N%n%O%n%A%n%Z %C', '\\d{4}', null],
  QA: [null, null, null],
  RE: ['%O%n%N%n%A%n%Z %C %X', '9[78]4\\d{2}', 'ACZ'],
  RO: ['%N%n%O%n%A%n%Z %S %C', '\\d{6}', 'ACZ'],
  RS: ['%N%n%O%n%A%n%Z %C', '\\d{5,6}', null],
  RU: ['%N%n%O%n%A%n%C%n%S%n%Z', '\\d{6}', 'ACSZ'],
  RW: [null, null, null],
  SA: ['%N%n%O%n%A%n%C %Z', '\\d{5}', null],
  SB: [null, null, null],
  SC: ['%N%n%O%n%A%n%C%n%S', null, null],
  SD: ['%N%n%O%n%A%n%C%n%Z', '\\d{5}', null],
  SE: ['%O%n%N%n%A%nSE-%Z %C', '\\d{3} ?\\d{2}', 'ACZ'],
  SG: ['%N%n%O%n%A%nSINGAPORE %Z', '\\d{6}', 'AZ'],
  SH: ['%N%n%O%n%A%n%C%n%Z', '(?:ASCN|STHL) 1ZZ', 'ACZ'],
  SI: ['%N%n%O%n%A%nSI-%Z %C', '\\d{4}', null],
  SJ: ['%N%n%O%n%A%n%Z %C', '\\d{4}', 'ACZ'],
  SK: ['%N%n%O%n%A%n%Z %C', '\\d{3} ?\\d{2}', 'ACZ'],
  SL: [null, null, null],
  SM: ['%N%n%O%n%A%n%Z %C', '4789\\d', 'AZ'],
  SN: ['%N%n%O%n%A%n%Z %C', '\\d{5}', null],
  SO: ['%N%n%O%n%A%n%C, %S %Z', '[A-Z]{2} ?\\d{5}', 'ACS'],
  SR: ['%N%n%O%n%A%n%C%n%S', null, null],
  SS: [null, null, null],
  ST: [null, null, null],
  SV: ['%N%n%O%n%A%n%Z-%C%n%S', 'CP [1-3][1-7][0-2]\\d', 'ACS'],
  SX: [null, null, null],
  SY: [null, null, null],
  SZ: ['%N%n%O%n%A%n%C%n%Z', '[HLMS]\\d{3}', null],
  TA: ['%N%n%O%n%A%n%C%n%Z', 'TDCU 1ZZ', null],
  TC: ['%N%n%O%n%A%n%C%n%Z', 'TKCA 1ZZ', 'ACZ'],
  TD: [null, null, null],
  TF: [null, null, null],
  TG: [null, null, null],
  TH: ['%N%n%O%n%A%n%D, %C%n%S %Z', '\\d{5}', null],
  TJ: ['%N%n%O%n%A%n%Z %C', '\\d{6}', null],
  TK: [null, null, null],
  TL: [null, null, null],
  TM: ['%N%n%O%n%A%n%Z %C', '\\d{6}', null],
  TN: ['%N%n%O%n%A%n%Z %C', '\\d{4}', null],
  TO: [null, null, null],
  TR: ['%N%n%O%n%A%n%Z %C/%S', '\\d{5}', 'ACZ'],
  TT: [null, null, null],
  TV: ['%N%n%O%n%A%n%C%n%S', null, null],
  TW: ['%N%n%O%n%A%n%C, %S %Z', '\\d{3}(?:\\d{2,3})?', 'ACSZ'],
  TZ: ['%N%n%O%n%A%n%Z %C', '\\d{4,5}', null],
  UA: ['%N%n%O%n%A%n%C%n%S%n%Z', '\\d{5}', 'ACZ'],
  UG: [null, null, null],
  UM: ['%N%n%O%n%A%n%C %S %Z', '96898', 'ACS'],
  US: ['%N%n%O%n%A%n%C, %S %Z', '(\\d{5})(?:[ \\-](\\d{4}))?', 'ACSZ'],
  UY: ['%N%n%O%n%A%n%Z %C %S', '\\d{5}', null],
  UZ: ['%N%n%O%n%A%n%Z %C%n%S', '\\d{6}', null],
  VA: ['%N%n%O%n%A%n%Z %C', '00120', null],
  VC: ['%N%n%O%n%A%n%C %Z', 'VC\\d{4}', null],
  VE: ['%N%n%O%n%A%n%C %Z, %S', '\\d{4}', 'ACS'],
  VG: ['%N%n%O%n%A%n%C%n%Z', 'VG\\d{4}', 'A'],
  VI: [
    '%N%n%O%n%A%n%C %S %Z',
    '(008(?:(?:[0-4]\\d)|(?:5[01])))(?:[ \\-](\\d{4}))?',
    'ACSZ',
  ],
  VN: ['%N%n%O%n%A%n%C%n%S %Z', '\\d{5}\\d?', null],
  VU: [null, null, null],
  WF: ['%O%n%N%n%A%n%Z %C %X', '986\\d{2}', 'ACZ'],
  WS: [null, null, null],
  XK: ['%N%n%O%n%A%n%Z %C', '[1-7]\\d{4}', null],
  YE: [null, null, null],
  YT: ['%O%n%N%n%A%n%Z %C %X', '976\\d{2}', 'ACZ'],
  ZA: ['%N%n%O%n%A%n%D%n%C%n%Z', '\\d{4}', 'ACZ'],
  ZM: ['%N%n%O%n%A%n%Z %C', '\\d{5}', null],
  ZW: [null, null, null],
};

// libaddressinput name types that differ from its defaults
// (city: 'city', state: 'province', zip: 'postal'), for fields the format shows.
export const NAME_TYPES = {
  AE: { state: 'emirate' },
  AS: { state: 'state', zip: 'zip' },
  AU: { city: 'suburb', state: 'state' },
  BB: { state: 'parish' },
  BR: { state: 'state' },
  BS: { state: 'island' },
  CO: { state: 'department' },
  CV: { state: 'island' },
  FM: { state: 'state', zip: 'zip' },
  GB: { city: 'post_town' },
  GU: { zip: 'zip' },
  HK: { city: 'district', state: 'area' },
  HN: { state: 'department' },
  IE: { state: 'county', zip: 'eircode' },
  IN: { state: 'state', zip: 'pin' },
  JM: { state: 'parish' },
  JP: { state: 'prefecture' },
  KI: { state: 'island' },
  KN: { state: 'island' },
  KR: { state: 'do_si' },
  KY: { state: 'island' },
  MH: { state: 'state', zip: 'zip' },
  MP: { state: 'state', zip: 'zip' },
  MX: { state: 'state' },
  MY: { state: 'state' },
  NG: { state: 'state' },
  NI: { state: 'department' },
  NO: { city: 'post_town' },
  NR: { state: 'district' },
  PE: { city: 'district' },
  PF: { state: 'island' },
  PR: { zip: 'zip' },
  PW: { state: 'state', zip: 'zip' },
  RU: { state: 'oblast' },
  SC: { state: 'island' },
  SD: { city: 'district' },
  SE: { city: 'post_town' },
  SJ: { city: 'post_town' },
  TR: { city: 'district' },
  TV: { state: 'island' },
  TW: { city: 'district', state: 'county' },
  UA: { state: 'oblast' },
  UM: { state: 'state', zip: 'zip' },
  US: { state: 'state', zip: 'zip' },
  VE: { state: 'state' },
  VI: { state: 'state', zip: 'zip' },
};

export const COUNTRY_CODES = Object.keys(COUNTRIES);

// Same return shape as lib-address/lite's getCountryData (minus sub_regions).
export function getCountryData(code) {
  const data = COUNTRIES[code];
  return data ? { code, lfmt: data[0], zip: data[1], require: data[2] } : null;
}
